/** Tokens visuais — cadastro de atletas (marca TNV) */
export const ATLETAS_ACCENT = "#F96030";

export const atletasToolbarSx = {
  mb: 2,
  p: 2,
  borderRadius: 2,
  bgcolor: "grey.50",
  border: "1px solid",
  borderColor: "grey.200",
  borderLeft: `4px solid ${ATLETAS_ACCENT}`,
};
